export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/elearning_video_production.b071da4.svg";